import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { NoAuthPageTemplate } from '../../layout/NoAuthPageTemplate/NoAuthPageTemplate';

interface Props {
  onRetry: () => Promise<unknown> | void;
  onSignOut: () => Promise<unknown> | void;
}

/**
 * Shown when a session is stored but the user or the role cannot load (no network, server down). The session is kept:
 * the user can try again, or log out on purpose.
 */
export const SessionUnavailable = ({ onRetry, onSignOut }: Props) => {
  const [retrying, setRetrying] = useState(false);

  const retry = async () => {
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <NoAuthPageTemplate icon='pi pi-wifi' color='error'>
      <h2>No se ha podido conectar</h2>
      <p>Comprueba tu conexión e inténtalo de nuevo. Tu sesión sigue abierta.</p>
      <Button label='Reintentar' icon='pi pi-refresh' loading={retrying} onClick={retry} />
      <Button label='Cerrar sesión' link onClick={() => onSignOut()} />
    </NoAuthPageTemplate>
  );
};
